<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<header>
<h1 class="topictitle1" id="ep2"><a href="#/nav#nep2"><span class="first_text">Epigraph</span></a></h1>
</header>
<div class="epi_group">
<p class="epigraph">Trust in the L<span class="small_caps">ord</span> with all your heart;
            </p>
<p class="epigraph">do not depend on your own understanding.</p>
<p class="epigraph_attribution">Proverbs 3:5</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?3a8a3926